import React, { createContext, useContext, useEffect, useState } from "react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    if (toasts.length === 0) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setToasts((current) => current.slice(1));
    }, 4200);

    return () => window.clearTimeout(timer);
  }, [toasts]);

  const pushToast = (toast) => {
    setToasts((current) => [
      ...current,
      { id: crypto.randomUUID(), tone: "neutral", ...toast }
    ]);
  };

  const dismissToast = (id) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  };

  return (
    <ToastContext.Provider value={pushToast}>
      {children}
      <div className="toast-stack" aria-live="polite" aria-atomic="true">
        {toasts.map((toast) => (
          <article key={toast.id} className={`toast toast-${toast.tone}`}>
            <div>
              <strong>{toast.title}</strong>
              <p>{toast.message}</p>
            </div>
            <div className="toast-actions">
              {toast.copyText ? (
                <button
                  type="button"
                  className="toast-copy"
                  onClick={async () => {
                    try {
                      await navigator.clipboard.writeText(toast.copyText);
                      dismissToast(toast.id);
                    } catch {
                      // Clipboard can fail on older mobile browsers; keep the toast visible.
                    }
                  }}
                >
                  Copy error
                </button>
              ) : null}
              <button type="button" className="toast-close" onClick={() => dismissToast(toast.id)}>
                Close
              </button>
            </div>
          </article>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return context;
}
